<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script>
import appConfig from "@/app.config";
import { notificationMethods } from "@/state/helpers";

export default {
  name: "app",
  page: {
    titleTemplate (title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },

  watch: {
    // eslint-disable-next-line no-unused-vars
    $route (to, from) {
      this.clearNotification();
    },
  },

  methods: {
    clearNotification: notificationMethods.clear,
  },

  async mounted () {
    this.$store.dispatch("layout/changeLoaderValue", true);

    // REACT NATIVE HANDLERS
    const nativeInterval = setInterval(() => {
      if (window.isNativeApp) {
        clearInterval(nativeInterval);

        // Send connection message
        // eslint-disable-next-line no-undef
        ReactNativeWebView.postMessage(
          JSON.stringify({ command: "CONNECTION", data: "CONNECTED" })
        );

        // eslint-disable-next-line no-undef
        ReactNativeWebView.postMessage(JSON.stringify({ command: "LOCATION" }));
        setInterval(() => {
          // eslint-disable-next-line no-undef
          ReactNativeWebView.postMessage(
            JSON.stringify({ command: "LOCATION" })
          );
        }, 5000);

        // Response Handlers
        window.postMessage = (message) => {
          switch (message.command) {
            case "LOCATION":
              this.$store.dispatch("gis/setLocation", {
                lat: message.data.latitude,
                long: message.data.longitude,
                speed: message.data.speed,
              });
              // this.$store.dispatch("gis/setDevices", [
              //   ...this.$store.getters["gis/devices"],
              //   { name: "GPS", status: message.data.status },
              // ]);
              break;

            case "DEVICE_TYPE":
              this.$store.dispatch("gis/setDeviceType", message.data.type);
              if (message.data.type === "TABLET") this.$router.push("/tablet");
              else this.$router.push("/phone/");
              this.$store.dispatch("layout/changeLoaderValue", false);
              break;

            case "DEVICE_STATUS":
              this.$store.dispatch("gis/setDevices", message.data);
              break;
          }
        };
      }
    }, 100);

    this.$router.push("/phone/")
    this.$store.dispatch("layout/changeLoaderValue", false);
  },
};
</script>